<template>
  <div :class="$style.bindGift">
    <header>
      <i class="iconfont yw-xiangzuo" @click="$emit('close')" />
      <span>绑定有礼</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="$emit('closePage')" :class="$style.closePage" />
    </header>
    <div :class="$style.content">
      <p>
        <img :src="`${$cdnLink}/common/time_ico_1.png`" alt="">
        <span :class="$style.label">活动时间</span>
        <span>{{ bindGiftInfo.date_detail }}</span>
      </p>
      <p>
        <img :src="`${$cdnLink}/common/bag_ico_1.png`" alt="">
        <span :class="$style.label">活动描述</span>
        <span>{{ bindGiftInfo.detail }}</span>
      </p>
    </div>
    <button :class="$style.submit" @click="$emit('bindPhone')" v-if="userState.tel_status == 0">绑定手机</button>
    <div v-else :class="$style.code">
      <span>礼包码：{{ code }}</span>
      <button :class="`${$style.copy} copy-btn`" :data-clipboard-text="code">复制</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getGiftNum } from '@/api/activity';
import Clipboard from 'clipboard';

export default {
  name: '',
  data() {
    return {
      code: '',
    };
  },
  mounted() {
    this.getCode();
    this.copyInit();
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
      bindGiftInfo: (state) => state.suspend.bindGift,
    }),
  },
  methods: {
    async getCode() {
      if (this.userState.tel_status == 0) return;

      const r = await getGiftNum({
        appkey: this.userState.appkey,
        user_id: this.userState.user_id,
        type: this.bindGiftInfo.type,
        id: this.bindGiftInfo.id,
      });
      this.code = r.content.gift_num;
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
      });
    },
  },
};
</script>

<style lang="scss" module>
.bindGift {
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  > header {
    position: relative;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    height: 40px;
    padding: 0 15px;
    color: #7a7979;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 40px;
    :global {
      .yw-xiangzuo {
        width: 15px;
        height: 15px;
        color: #7a7979;
      }
    }
    .closePage {
      height: 13px;
    }
  }
  .content {
    > p {
      font-size: 12px;
      padding: 5px 0;
      margin: 0 40px 0 10px;
      display: flex;
      line-height: 16px;
      > .label {
        flex: none;
        margin-right: 5px;
      }
      > img {
        height: 15px;
        margin-right: 6px;
      }
    }
    > p:nth-child(1) {
      border-bottom: 1px solid #cccccc;
    }
  }
  .submit {
    margin: 54px auto 0;
    width: 293px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 15px;
    border: none;
    outline: none;
    background: #ff5b58;
    border-radius: 20px;
  }
  .code {
    font-size: 14px;
    text-align: center;
    margin-top: 60px;
    .copy {
      padding: 4px 12px;
      color: #ffffff;
      border: none;
      outline: none;
      font-size: 12px;
      background: #ff5b58;
      border-radius: 10px;
      margin-left: 20px;
    }
  }
}
</style>
